import { useEffect } from 'react';
import { useRouterState } from '@tanstack/react-router';
import { bootstrapAuth } from '../stores/bootstrap';

// FR-12 : la page publique de suivi ne déclenche aucun refresh. Un client
// final n'a pas de session, et un /auth/refresh qui 401 depuis son
// navigateur est une requête de session de trop sur la seule surface anonyme
// du produit. Le boot repart dès qu'on quitte la zone publique.
const PUBLIC_PREFIX = '/suivi/';

/**
 * Déclenche le silent refresh unique au démarrage client. Rend null : simple
 * effet de bord monté une fois. `useEffect` garantit le client-only et le
 * non-bloquant — un visiteur anonyme paie un /auth/refresh qui 401 en
 * silence, sans retarder le premier render.
 */
export function AuthBootstrap() {
  const isPublic = useRouterState({
    select: (state) => state.location.pathname.startsWith(PUBLIC_PREFIX),
  });
  useEffect(() => {
    if (!isPublic) void bootstrapAuth();
  }, [isPublic]);
  return null;
}
